import { useMemo } from 'react';

import { useFetchClients } from 'hooks/queries/client';
import { IClientProps } from 'types/components/client';

import { useExternalClients } from './external.hook';
import { useAddMissingClients } from './missing.hook';
import { useSelectedClients } from './selected.hook';

export const useRetrieveClients = <AllowMultiple extends boolean = false>({
  selected,
  useExternal = false,
}: Pick<IClientProps<AllowMultiple>, 'selected' | 'useExternal'>) => {
  const { data: clients = [], isFetching } = useFetchClients();
  let original = useMemo(() => [...clients], [clients]);

  original = useAddMissingClients(original, selected);
  original = useExternalClients(original, useExternal);

  const selectedClients = useSelectedClients({ clients: original, selected });

  return {
    clients: original,
    isFetching,
    selectedClients,
  };
};
